import { NOTIFICATION_FRAGMENT } from "@graphql"

const addNotificationToCache = (cache, createNotification, eventId) => {
  cache.modify({
    id: cache.identify({ __typename: "Event", id: eventId }),
    fields: {
      notifications(existingRefs = []) {
        const newRef = cache.writeFragment({
          data: createNotification,
          fragment: NOTIFICATION_FRAGMENT,
        })

        // Optional: check for duplicates by ID
        if (existingRefs.some(ref => ref.__ref === newRef.__ref)) {
          return existingRefs
        }

        return [newRef, ...existingRefs]
      }
    }
  })
}

export default addNotificationToCache